var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.toggleOptions.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.opened,
                  expression: "opened",
                },
              ],
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._l(_vm.optionsParsed, function (option) {
                return _c(
                  "div",
                  { key: option.id, staticClass: "faixa-container" },
                  [
                    _c("div", { staticClass: "faixa-option" }, [
                      _c("div", { staticClass: "faixa-option-info" }, [
                        _c("b", [
                          _c("span", { style: { color: _vm.colorNameLote } }, [
                            _vm._v(
                              "\n                  [" +
                                _vm._s(option.nome_lote.toUpperCase()) +
                                "]\n                "
                            ),
                          ]),
                          _vm._v(
                            " \n                " +
                              _vm._s(option.nome.toUpperCase()) +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.getCurrentPrice(option).precoDe
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "lightgray",
                                  "text-decoration": "line-through",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatMoney(
                                      _vm.getCurrentPrice(option).precoDe
                                    )
                                  ) + " \n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.cobrarTaxa
                          ? _c(
                              "span",
                              {
                                style: {
                                  color: _vm.primaryColor,
                                  fontWeight: 500,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formatMoney(
                                        _vm.getCurrentPrice(option).preco
                                      )
                                    ) +
                                    "\n                "
                                ),
                                _c("span", [
                                  _vm._v(
                                    "(+ " +
                                      _vm._s(
                                        _vm.formatMoney(
                                          _vm.calculateTaxForNetValue(
                                            _vm.getCurrentPrice(option).preco,
                                            _vm.taxa
                                          )
                                        )
                                      ) +
                                      " taxa)"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(option.descricao) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                style: {
                                  color: _vm.primaryColor,
                                  fontWeight: 500,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formatMoney(
                                        _vm.getCurrentPrice(option).preco
                                      )
                                    ) +
                                    "\n                (" +
                                    _vm._s(option.descricao) +
                                    ")\n              "
                                ),
                              ]
                            ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        option.combo
                          ? _c(
                              "div",
                              { staticStyle: { "font-size": "10px" } },
                              _vm._l(
                                option.disponibilidade_id,
                                function (dateTime, i) {
                                  return _c("div", { key: i }, [
                                    _c("span", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            option.nomesFaixasOriginais[
                                              i
                                            ].toUpperCase()
                                          )
                                        ),
                                      ]),
                                      _vm._v(" - "),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getAvailableForCombo(
                                            option.datas_originais[i]
                                          )
                                        ) +
                                          " " +
                                          _vm._s(
                                            option.label[i]
                                              ? `- ${option.label[i]}`
                                              : ""
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    option.datas_originais.length == 1
                                      ? _c("span", [
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("b", [
                                            _vm._v(_vm._s("CASADINHA")),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ])
                                }
                              ),
                              0
                            )
                          : _c(
                              "span",
                              { staticStyle: { "font-size": "10px" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getAvailable(option.disponibilidade_id)
                                  )
                                ),
                              ]
                            ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "faixa-option-quantity",
                          attrs: { translate: "no" },
                        },
                        [
                          _c(
                            "div",
                            {
                              class: {
                                "disabled-quantity":
                                  _vm.getCurrentQuantidade(option) == 0,
                                "add-quantity":
                                  _vm.getCurrentQuantidade(option) > 0,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-minus p-1",
                                on: {
                                  click: function ($event) {
                                    _vm.sub(option)
                                    _vm.setValidateQuantity(option, false, true)
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "faixa-option-quantity-display" },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.getCurrentQuantidade(option))
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                "add-quantity": !_vm.validateQuantity(option),
                                "disabled-quantity":
                                  _vm.validateQuantity(option),
                              },
                            },
                            [
                              _c("i", {
                                class: { "fa-solid fa-plus p-1": true },
                                on: {
                                  click: function ($event) {
                                    _vm.add(option)
                                    _vm.setValidateQuantity(option, true, false)
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.$props.selectedAvailability && _vm.optionsParsed.length == 0
                ? _c("div", { staticClass: "faixa-container" }, [
                    _c("span", { staticClass: "p-4" }, [
                      _vm._v("Nenhum ingresso disponível."),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isDependentOnly
                ? _c("div", [
                    _c("small", [
                      _vm._v(
                        "É necessário adicionar ao menos 1 não dependente"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.minVenda > 1 || _vm.maxVenda < Infinity
                ? _c("div", { staticClass: "compliance-alert" }, [
                    _vm.minVenda > 1 && _vm.maxVenda < Infinity
                      ? _c("small", [
                          _vm._v(
                            "O máximo de vagas para a compra dessa atividade por pessoa é: " +
                              _vm._s(_vm.maxVenda) +
                              " (caso tenha disponibilidade). E no mínimo " +
                              _vm._s(_vm.minVenda) +
                              "."
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.minVenda <= 1 && _vm.maxVenda < Infinity
                      ? _c("small", [
                          _vm._v(
                            "O máximo de vagas para a compra dessa atividade por pessoa é: " +
                              _vm._s(_vm.maxVenda) +
                              " (caso tenha disponibilidade)."
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.minVenda > 1 && _vm.maxVenda >= Infinity
                      ? _c("small", [
                          _vm._v(
                            "O mínimo de vagas para a compra dessa atividade por pessoa é: " +
                              _vm._s(_vm.minVenda) +
                              " (caso tenha disponibilidade)."
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }